export { default as SENTRY_COLORS } from './sentry';
export { default as INSIGHT_COLORS } from './insight';
